<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM开单实时数据（元）"
      rightTitle="今日合计：888881"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_1" slot="main"/>
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_1",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_1"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "2%",
          top: "center",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
          "#AFEEEE",
        ],
        series: [
          {
            name: "PDM开单实时数据",
            type: "pie",
            radius: ["40%", "60%"],
            left: "16%",
            data: [
              { value: 248, name: "商家1" },
              { value: 735, name: "商家2" },
              { value: 580, name: "商家3" },
              { value: 484, name: "商家4" },
              { value: 100, name: "商家5" },
              { value: 600, name: "商家6" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #left_1 {
    height: 100%;
  }
}
</style>
